import React, {Component, useEffect, useState} from 'react';
import './RequestGetPassword.css';
import { FaUserAlt, FaLock, FaEnvelope, FaUserLock, FaUserTie, FaUniversity } from "react-icons/fa";
import back from '../../assets/Group 1.svg';
import queryString from 'query-string'

import { useMutation } from '@apollo/client';
import { REQUEST_GET_PASSWORD } from '../../queries'

const RequestGetPassword = (props) => {
    const values = queryString.parse(props.location.search)
    const [ RequestGetPassword, { data, /*loading,*/ error }] = useMutation(REQUEST_GET_PASSWORD);

    const [errorLog, setErrorLog] = useState('');
    useEffect(()=>{
        console.log(error)
        if(error) {
            setErrorLog(error.message);
        }
    }, [error]);

  return (
    <RequestGetPasswordForm errorLog={errorLog}  token={values.token} RequestGetPassword={RequestGetPassword}/>
  )
}


class RequestGetPasswordForm extends Component{
    constructor(props) {
        super(props);
        this.state = {
            email: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        // this.handleValidation = this.handleValidation.bind(this);
    }

    handleValidation(){
        if (!this.state.email){
                console.log("bisa");
                this.setState({
                    errorForm: "Isi Form!",
                }, () => alert(this.state.errorForm))
                return 0;
            }
        return 1;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();
        if (this.handleValidation()){
            const o = { variables: {
                email: this.state.email,
              }};      
      
              try {
                await this.props.RequestGetPassword(o);
                this.setState({
                    email: '',
                });
                window.location = '/signin';
              }
                  catch (e) {
              }
        }

    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className="container-fluid m-0 p-0">
                    <div className="signcontain">
                        <div className="row m-0 p-0 row1">
                            <div className="col-md-6 logcol p-0 m-0">
                                <div className="login-box">
                                    <h1>Lupa Password</h1>
                                    <div className="textbox">
                                        <FaLock className="pass"/>
                                        <input
                                            name="email"
                                            type="text"
                                            placeholder="Email"
                                            onChange={this.handleInputChange}
                                            value={this.state.email}
                                        />
                                    </div>
                                    {this.props.errorLog ?
                                        <p className="errorMsg">{this.props.errorLog}</p>:
                                        <></>
                                    }
                                    <button type="submit" className="btn btnsign">Submit</button>
                                </div>
                            </div>
                            <div className="col-md-6 backg m-0 p-0">
                                <div className="background">
                                    <img src={back} alt="logo" className="logoback"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        )
    }
}

export default RequestGetPassword;
